import { useMutation, useQuery, useQueryClient } from 'react-query';

import { QueryKeys } from '@frontend/features/common/types';

import { agencyKnowledgeApi } from './api';
import {
  CreateAgencyKnowledgePayload,
  UpdateAgencyKnowledgePayload,
} from './types';

export const useAgencyKnowledge = (agencyId: number) =>
  useQuery({
    queryKey: [QueryKeys.getAgencyKnowledge, agencyId],
    queryFn: () => agencyKnowledgeApi.list(agencyId),
    enabled: Boolean(agencyId),
  });

export const useAgencyKnowledgeTags = (agencyId: number) =>
  useQuery({
    queryKey: [QueryKeys.getAgencyKnowledgeTags, agencyId],
    queryFn: () => agencyKnowledgeApi.tags(agencyId),
    enabled: Boolean(agencyId),
  });

export const useCreateAgencyKnowledge = (agencyId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateAgencyKnowledgePayload) =>
      agencyKnowledgeApi.create(agencyId, payload),
    onSuccess: () => {
      void qc.invalidateQueries([QueryKeys.getAgencyKnowledge]);
      void qc.invalidateQueries([QueryKeys.getAgencyKnowledgeTags]);
    },
  });
};

export const useUpdateAgencyKnowledge = (agencyId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateAgencyKnowledgePayload;
    }) => agencyKnowledgeApi.update(agencyId, id, payload),
    onSuccess: () => {
      void qc.invalidateQueries([QueryKeys.getAgencyKnowledge]);
      void qc.invalidateQueries([QueryKeys.getAgencyKnowledgeTags]);
    },
  });
};

export const useDeleteAgencyKnowledge = (agencyId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => agencyKnowledgeApi.remove(agencyId, id),
    onSuccess: () => {
      void qc.invalidateQueries([QueryKeys.getAgencyKnowledge]);
    },
  });
};
